import { useAuth, useLoad } from "../lib/api.jsx";
import { Wait, Tbl } from "../lib/ui.jsx";

export default function Trash() {
  const { act } = useAuth();
  const [d, reload] = useLoad("trash");
  return (
    <>
      <h1>Trash</h1>
      <p className="muted">Deleted users are archived here. Restore brings back the profile, verification state and portal access.</p>
      <Wait d={d}>
        {d && !d.error && (
          <Tbl rows={d.rows} empty="Trash is empty." cols={[
            ["Deleted", (t) => t.time_stamp], ["Type", (t) => t.item_for], ["Name", (t) => t.name || t.user_id || "-"],
            ["Email", (t) => t.email || "-"], ["Note", (t) => t.note || "-"],
            ["", (t) => (
              <>
                {t.restorable && t.item_for === "user" && (
                  <button className="btn g s" onClick={() => act("trash_restore", { id: t.id }, "User restored.").then(reload)}>Restore</button>
                )}{" "}
                <button className="btn d s" onClick={() => confirm("Delete permanently? This cannot be undone.") && act("trash_purge", { id: t.id }, "Purged.").then(reload)}>Purge</button>
              </>
            )],
          ]} />
        )}
      </Wait>
    </>
  );
}
